.nest-toast {
  @apply relative border border-input rounded mt-2 py-4 px-8 bg-background break-all shadow-2xl;

  nest-icon {
    @apply hover:cursor-pointer absolute top-0 right-0 w-5 h-5 mt-6 mr-6;
  }
}

#nest-modals {
  @apply fixed top-12 right-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:flex-col max-w-[420px];
}
